import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const getCommentText = macroSelected => {
  if (macroSelected) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.send-button.capabilities-editor-submit-button.comment-with-macro"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.send-button.capabilities-editor-submit-button.comment"
  });
};
const getMessageText = (count, macroSelected, compact) => {
  if (compact || !count || count === 1) {
    if (macroSelected) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.send-button.capabilities-editor-submit-button.send-with-macro"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.send-button.capabilities-editor-submit-button.send"
    });
  }
  if (macroSelected) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.send-button.capabilities-editor-submit-button.send-count-with-macro",
      options: {
        count
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.send-button.capabilities-editor-submit-button.send-count",
    options: {
      count
    }
  });
};
const CapabilitiesEditorSubmitButtonText = ({
  editorConfigurationKey,
  count = 1,
  macroSelected = false,
  compact = false
}) => {
  if (editorConfigurationKey === 'THREAD_COMMENT') {
    return getCommentText(macroSelected);
  }
  return getMessageText(count, macroSelected, compact);
};
CapabilitiesEditorSubmitButtonText.displayName = 'CapabilitiesEditorSubmitButtonText';
export default CapabilitiesEditorSubmitButtonText;